// NEW_FILE_JUSTIFIED: Reusable utilization progress bar component — used by BenefitItemCard for amount and visit tracking
import { cn } from '@/lib/utils';
import {
  getUtilizationColor,
  getUtilizationTextColor,
  getUtilizationPercent,
} from '@/lib/coverage-utils';
import type { IUtilizationBarProps } from '@/@types/coverage';

export function UtilizationBar({
  usedValue,
  totalValue,
  usedLabel,
  remainingLabel,
  limitLabel,
}: IUtilizationBarProps) {
  const pct = getUtilizationPercent(usedValue, totalValue);

  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center justify-between">
        <span className={cn('text-sm font-medium', getUtilizationTextColor(pct))}>
          {usedLabel}
        </span>
        <span className="text-sm font-medium text-muted-foreground">{remainingLabel}</span>
      </div>

      <div className="relative h-1.5 w-full rounded-sm bg-muted overflow-hidden">
        <div
          className={cn('absolute inset-y-0 left-0 rounded-sm', getUtilizationColor(pct))}
          style={{ width: `${pct}%` }}
        />
      </div>

      <div className="flex items-center justify-between">
        <span className="text-xs text-foreground-muted">{limitLabel}</span>
        <span className="text-xs text-foreground-muted">{pct}% used</span>
      </div>
    </div>
  );
}
